import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column'
  },

  noTasks: {
    fontSize: theme.size.sm,
    color: '#657786',
    cursor: 'default',
    userSelect: 'none'
  }
}))

export default useStyles
